import Client from "./Client";
import EventEmitter from "../EventEmitter";
const uri = 'v1/hrpress/post-clips', client = new Client();
let current;
class FavoriteClient extends EventEmitter {
    request(fn, id) {
        if (id) {
            this.fire('connect', [id]);
        }
        return new Promise((resolve, reject) => {
            fn
                .then(response => {
                const data = response.data.data;
                resolve(data);
                this.fire('change', data.clips);
            })
                .catch(e => {
                reject(e);
            });
        });
    }
    /**
     * シリアル接続(リクエスト順に処理を行う)を実施
     * @param method
     * @param uri
     * @param id
     * @protected
     */
    serial(method, uri, id) {
        const promise = current = new Promise((resolve, reject) => {
            if (current) {
                current = current.finally(() => {
                    this.request(client.request(method, uri), id).then(r => resolve(r));
                });
            }
            else {
                current = this.request(client.request(method, uri), id).then(r => resolve(r));
            }
        });
        promise.finally(() => {
            if (current === promise) {
                current = undefined;
            }
        });
        return promise;
    }
    get() {
        return this.request(client.get(uri));
    }
    post(id) {
        return this.serial("POST", `${uri}/${id}`, id);
    }
    delete(id) {
        return this.serial("DELETE", `${uri}/${id}`, id);
    }
}
export default new FavoriteClient();
